// extracted by mini-css-extract-plugin
export default {"logo":"Logo_logo__vDBPO","txt":"Logo_txt__NT8B0","circle":"Logo_circle__OlnII","navItem":"Logo_navItem__OvVSr"};